/**
 * Gift Card Bonus Module
 * Auto-adds/removes bonus gift cards when trigger products are in cart
 */

(function() {
  'use strict';

  console.log('🎁 Gift Card Bonus: Script loaded');

  var config = window.theme && window.theme.giftCardBonus;

  console.log('🎁 Gift Card Bonus: Config:', config);

  if (!config) {
    console.log('🎁 Gift Card Bonus: No config found - feature disabled or not configured');
    return;
  }

  if (!config.enabled) {
    console.log('🎁 Gift Card Bonus: Feature is disabled');
    return;
  }

  if (!config.tiers || config.tiers.length === 0) {
    console.log('🎁 Gift Card Bonus: No tiers configured');
    return;
  }

  console.log('🎁 Gift Card Bonus: Enabled with', config.tiers.length, 'tier(s)');
  console.log('🎁 Gift Card Bonus: Tiers:', JSON.stringify(config.tiers, null, 2));

  var BONUS_PROPERTY_KEY = '_bonus_gift_card';
  var isProcessing = false;

  // Sort tiers by tier number descending (highest tier wins)
  var sortedTiers = config.tiers.slice().sort(function(a, b) {
    return b.tier - a.tier;
  });

  /**
   * Find all bonus items in cart by property
   * Returns array of {variantId, quantity, key} objects
   */
  function findAllBonusesInCart(cart) {
    var bonuses = [];
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.properties && item.properties[BONUS_PROPERTY_KEY] === 'true') {
        console.log('🎁 Gift Card Bonus: Found bonus in cart:', item.variant_id, 'qty:', item.quantity);
        bonuses.push({
          variantId: item.variant_id,
          quantity: item.quantity,
          key: item.key
        });
      }
    }
    console.log('🎁 Gift Card Bonus: Found', bonuses.length, 'bonus item(s) in cart');
    return bonuses;
  }

  /**
   * Find all triggers present in cart
   * Returns array of {tier, quantity} objects
   */
  function findAllTriggers(cart) {
    console.log('🎁 Gift Card Bonus: Searching for all triggers in cart...');
    var triggers = [];

    for (var i = 0; i < sortedTiers.length; i++) {
      var tier = sortedTiers[i];

      for (var j = 0; j < cart.items.length; j++) {
        var item = cart.items[j];
        // Skip bonus items
        if (item.properties && item.properties[BONUS_PROPERTY_KEY] === 'true') {
          continue;
        }

        if (item.variant_id === tier.triggerVariantId) {
          console.log('🎁 Gift Card Bonus: Found trigger for tier', tier.tier, 'qty:', item.quantity);
          triggers.push({
            tier: tier,
            quantity: item.quantity
          });
        }
      }
    }
    console.log('🎁 Gift Card Bonus: Found', triggers.length, 'trigger(s) in cart');
    return triggers;
  }

  /**
   * Calculate expected bonuses based on triggers
   * Returns object {bonusVariantId: expectedQuantity, ...}
   */
  function calculateExpectedBonuses(triggers) {
    var expected = {};
    for (var i = 0; i < triggers.length; i++) {
      var trigger = triggers[i];
      var bonusId = trigger.tier.bonusVariantId;
      expected[bonusId] = (expected[bonusId] || 0) + trigger.quantity;
    }
    console.log('🎁 Gift Card Bonus: Expected bonuses:', expected);
    return expected;
  }

  /**
   * Add bonus product to cart with specified quantity
   */
  function addBonus(variantId, quantity) {
    console.log('🎁 Gift Card Bonus: Adding bonus variant', variantId, 'qty:', quantity);

    var properties = {};
    properties[BONUS_PROPERTY_KEY] = 'true';

    return fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: quantity,
          properties: properties
        }]
      })
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      console.log('🎁 Gift Card Bonus: Add response:', data);
      return data;
    });
  }

  /**
   * Update bonus quantity in cart
   */
  function updateBonusQuantity(itemKey, quantity) {
    console.log('🎁 Gift Card Bonus: Updating bonus', itemKey, 'to qty:', quantity);

    return fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      console.log('🎁 Gift Card Bonus: Update response:', data);
      return data;
    });
  }

  /**
   * Remove bonus product from cart
   */
  function removeBonus(itemKey) {
    console.log('🎁 Gift Card Bonus: Removing bonus with key', itemKey);

    return fetch(theme.routes.cartChange, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0
      })
    }).then(function(response) {
      return response.json();
    }).then(function(data) {
      console.log('🎁 Gift Card Bonus: Remove response:', data);
      return data;
    });
  }

  /**
   * Refresh cart UI
   */
  function refreshCart() {
    console.log('🎁 Gift Card Bonus: Refreshing cart UI');
    document.dispatchEvent(new Event('cart:build'));
  }

  /**
   * Main sync function - handles multiple stacking bonuses
   */
  function syncBonus() {
    if (isProcessing) {
      console.log('🎁 Gift Card Bonus: Already processing, skipping');
      return;
    }
    isProcessing = true;
    console.log('🎁 Gift Card Bonus: Starting sync...');

    theme.cart.getCart()
      .then(function(cart) {
        console.log('🎁 Gift Card Bonus: Got cart with', cart.items.length, 'items');

        var triggers = findAllTriggers(cart);
        var expectedBonuses = calculateExpectedBonuses(triggers);
        var currentBonuses = findAllBonusesInCart(cart);

        // Build a map of current bonuses by variant ID
        var currentBonusMap = {};
        for (var i = 0; i < currentBonuses.length; i++) {
          var bonus = currentBonuses[i];
          currentBonusMap[bonus.variantId] = bonus;
        }

        // Build list of operations needed
        var operations = [];

        // Check each expected bonus
        var expectedVariantIds = Object.keys(expectedBonuses);
        for (var j = 0; j < expectedVariantIds.length; j++) {
          var variantId = parseInt(expectedVariantIds[j]);
          var expectedQty = expectedBonuses[variantId];
          var current = currentBonusMap[variantId];

          if (!current) {
            // Bonus doesn't exist - add it
            console.log('🎁 Gift Card Bonus: Need to add bonus', variantId, 'qty:', expectedQty);
            operations.push({ type: 'add', variantId: variantId, quantity: expectedQty });
          } else if (current.quantity !== expectedQty) {
            // Bonus exists but wrong quantity - update it
            console.log('🎁 Gift Card Bonus: Need to update bonus', variantId, 'from', current.quantity, 'to', expectedQty);
            operations.push({ type: 'update', key: current.key, quantity: expectedQty });
          } else {
            console.log('🎁 Gift Card Bonus: Bonus', variantId, 'already correct');
          }
        }

        // Check for orphaned bonuses that should be removed
        for (var k = 0; k < currentBonuses.length; k++) {
          var currentBonus = currentBonuses[k];
          if (!expectedBonuses[currentBonus.variantId]) {
            console.log('🎁 Gift Card Bonus: Need to remove orphaned bonus', currentBonus.variantId);
            operations.push({ type: 'remove', key: currentBonus.key });
          }
        }

        // Execute operations sequentially
        if (operations.length === 0) {
          console.log('🎁 Gift Card Bonus: No changes needed');
          return;
        }

        console.log('🎁 Gift Card Bonus: Executing', operations.length, 'operation(s)');

        var chain = Promise.resolve();
        for (var m = 0; m < operations.length; m++) {
          (function(op) {
            chain = chain.then(function() {
              if (op.type === 'add') {
                return addBonus(op.variantId, op.quantity);
              } else if (op.type === 'update') {
                return updateBonusQuantity(op.key, op.quantity);
              } else if (op.type === 'remove') {
                return removeBonus(op.key);
              }
            });
          })(operations[m]);
        }

        return chain.then(function() {
          refreshCart();
        });
      })
      .catch(function(err) {
        console.error('🎁 Gift Card Bonus: Error:', err);
      })
      .finally(function() {
        isProcessing = false;
        console.log('🎁 Gift Card Bonus: Sync complete');
      });
  }

  /**
   * Initialize
   */
  function init() {
    console.log('🎁 Gift Card Bonus: Initializing...');

    // Listen for cart updates
    document.addEventListener('cart:updated', function() {
      console.log('🎁 Gift Card Bonus: cart:updated event received');
      setTimeout(syncBonus, 100);
    });

    // Listen for products added
    document.addEventListener('ajaxProduct:added', function() {
      console.log('🎁 Gift Card Bonus: ajaxProduct:added event received');
      setTimeout(syncBonus, 300);
    });

    // Initial sync
    console.log('🎁 Gift Card Bonus: Running initial sync...');
    syncBonus();

    console.log('🎁 Gift Card Bonus: Initialization complete');
  }

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
